import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

export default function SplashScreen() {
    const [isDisplay, setIsDisplay] = useState(true)
    const startSplashScreen = () => {
        setTimeout(() => {
            setIsDisplay(false)
        }, 1500)
    }
    useEffect(() => {
        startSplashScreen()
    }, [])
    if (isDisplay)
        return (
            <div style={{
                width: "100%",
                height: "auto",
                maxHeight: "100vh"
            }}>
                <img
                    src="/assets/images/splashscreen.png"
                    alt="splashscreen"
                    style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "100vh"
                    }}
                />
            </div>
        )
}
